import React, { useState } from 'react';
import { Share2Icon, UserPlusIcon, TrendingUpIcon, UsersIcon, PlusIcon, LinkIcon, ChevronUpIcon, ChevronDownIcon, ArrowRightIcon } from 'lucide-react';
export const ReferRocket = () => {
  const [sortField, setSortField] = useState<'name' | 'referrals' | 'conversions' | 'rate' | 'rewards'>('referrals');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const referrers = [{
    name: 'Max Mustermann',
    company: 'Tech Solutions GmbH',
    referrals: 12,
    conversions: 5,
    rate: '41.7',
    rewards: '250'
  }, {
    name: 'Anna Schmidt',
    company: 'Digital Marketing AG',
    referrals: 9,
    conversions: 3,
    rate: '33.3%',
    rewards: '€150'
  }, {
    name: 'Thomas Weber',
    company: 'Innovative IT GmbH',
    referrals: 7,
    conversions: 4,
    rate: '57.1%',
    rewards: '€200'
  }, {
    name: 'Sarah Müller',
    company: 'Web Design Studio',
    referrals: 5,
    conversions: 2,
    rate: '40.0%',
    rewards: '€100'
  }];
  const handleSort = (field: typeof sortField) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  const renderSortIndicator = (field: typeof sortField) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <ChevronUpIcon size={16} className="ml-1" data-id="element-356" /> : <ChevronDownIcon size={16} className="ml-1" data-id="element-357" />;
  };
  const sortedReferrers = [...referrers].sort((a, b) => {
    let compareA = a[sortField];
    let compareB = b[sortField];
    // Convert percentage strings and currency to numbers
    if (sortField === 'rate') {
      compareA = parseFloat(compareA);
      compareB = parseFloat(compareB);
    }
    if (sortField === 'rewards') {
      compareA = parseInt(compareA);
      compareB = parseInt(compareB);
    }
    if (compareA < compareB) return sortDirection === 'asc' ? -1 : 1;
    if (compareA > compareB) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
  return <div className="space-y-6" data-id="element-358">
      <div className="flex items-center justify-between" data-id="element-359">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-360">
          Empfehlungsprogramme
        </h2>
        <button className="px-4 py-2 bg-orange-500 rounded-lg text-sm font-medium text-white flex items-center hover:bg-orange-600" data-id="element-361">
          <PlusIcon size={16} className="mr-2" data-id="element-362" />
          Neues Programm
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-363">
        {[{
        title: 'Aktive Empfehlungen',
        value: '124',
        icon: <Share2Icon size={18} className="text-orange-500" data-id="element-364" />
      }, {
        title: 'Neue Leads',
        value: '37',
        icon: <UserPlusIcon size={18} className="text-green-500" data-id="element-365" />
      }, {
        title: 'Conversion-Rate',
        value: '29.8%',
        icon: <TrendingUpIcon size={18} className="text-blue-500" data-id="element-366" />
      }].map((stat, index) => <div key={index} className="bg-white rounded-lg shadow p-5" data-id="element-367">
            <div className="flex justify-between items-center mb-4" data-id="element-368">
              <p className="text-sm font-medium text-gray-500" data-id="element-369">{stat.title}</p>
              <div className="p-2 rounded-full bg-gray-100" data-id="element-370">{stat.icon}</div>
            </div>
            <p className="text-2xl font-bold text-gray-800" data-id="element-371">{stat.value}</p>
          </div>)}
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-372">
        <div className="p-5 border-b border-gray-200" data-id="element-373">
          <h3 className="text-lg font-medium text-gray-800" data-id="element-374">Top Empfehler</h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-375">
            Kunden, die am aktivsten Empfehlungen aussprechen
          </p>
        </div>
        <div className="overflow-x-auto" data-id="element-376">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-377">
            <thead className="bg-gray-50" data-id="element-378">
              <tr data-id="element-379">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('name')} data-id="element-380">
                  <div className="flex items-center" data-id="element-381">
                    Kunde
                    {renderSortIndicator('name')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('referrals')} data-id="element-382">
                  <div className="flex items-center" data-id="element-383">
                    Empfehlungen
                    {renderSortIndicator('referrals')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('conversions')} data-id="element-384">
                  <div className="flex items-center" data-id="element-385">
                    Konversionen
                    {renderSortIndicator('conversions')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('rate')} data-id="element-386">
                  <div className="flex items-center" data-id="element-387">
                    Conversion-Rate
                    {renderSortIndicator('rate')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('rewards')} data-id="element-388">
                  <div className="flex items-center" data-id="element-389">
                    Verdiente Prämien
                    {renderSortIndicator('rewards')}
                  </div>
                </th>
                <th scope="col" className="relative px-6 py-3" data-id="element-390">
                  <span className="sr-only" data-id="element-391">Aktionen</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-392">
              {sortedReferrers.map((referrer, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-393">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-394">
                    <div className="flex items-center" data-id="element-395">
                      <div className="flex-shrink-0 h-10 w-10 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-396">
                        <UsersIcon size={18} className="text-orange-500" data-id="element-397" />
                      </div>
                      <div className="ml-4" data-id="element-398">
                        <div className="text-sm font-medium text-gray-900" data-id="element-399">
                          {referrer.name}
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-400">
                          {referrer.company}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-401">
                    <div className="text-sm text-gray-900" data-id="element-402">
                      {referrer.referrals}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-403">
                    <div className="text-sm text-gray-900" data-id="element-404">
                      {referrer.conversions}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-405">
                    <div className="text-sm text-gray-900" data-id="element-406">{referrer.rate}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-407">
                    <div className="text-sm font-medium text-gray-900" data-id="element-408">
                      {referrer.rewards}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-409">
                    <button className="text-orange-500 hover:text-orange-700 flex items-center justify-end" data-id="element-410">
                      Details
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-411" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-412">
        <div className="bg-white rounded-lg shadow" data-id="element-413">
          <div className="p-5 border-b border-gray-200" data-id="element-414">
            <h3 className="text-lg font-medium text-gray-800" data-id="element-415">
              Empfehlungs-Link erstellen
            </h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-416">
              Generieren Sie personalisierte Links für Ihre Kunden
            </p>
          </div>
          <div className="p-5 space-y-4" data-id="element-417">
            <div className="space-y-2" data-id="element-418">
              <label className="text-sm font-medium text-gray-700" data-id="element-419">
                Kunde auswählen
              </label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-420">
                <option data-id="element-421">Bitte Kunden auswählen...</option>
                <option data-id="element-422">Tech Solutions GmbH</option>
                <option data-id="element-423">Digital Marketing AG</option>
                <option data-id="element-424">Innovative IT GmbH</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-425">
              <label className="text-sm font-medium text-gray-700" data-id="element-426">
                Kampagne
              </label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-427">
                <option data-id="element-428">Standard-Empfehlungsprogramm</option>
                <option data-id="element-429">Premium-Partner-Programm</option>
                <option data-id="element-430">Sommer-Aktion 2023</option>
              </select>
            </div>
            <button className="w-full px-4 py-2 bg-orange-500 rounded-lg text-sm font-medium text-white flex items-center justify-center hover:bg-orange-600" data-id="element-431">
              <LinkIcon size={16} className="mr-2" data-id="element-432" />
              Link generieren
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow" data-id="element-433">
          <div className="p-5 border-b border-gray-200" data-id="element-434">
            <h3 className="text-lg font-medium text-gray-800" data-id="element-435">
              Prämien-Übersicht
            </h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-436">
              Aktuelle Prämien und Belohnungen für Empfehlungen
            </p>
          </div>
          <div className="p-5" data-id="element-437">
            <div className="space-y-4" data-id="element-438">
              <div className="flex justify-between items-center pb-3 border-b border-gray-100" data-id="element-439">
                <div data-id="element-440">
                  <h4 className="text-sm font-medium text-gray-800" data-id="element-441">
                    1 erfolgreiche Empfehlung
                  </h4>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-442">Amazon-Gutschein</p>
                </div>
                <span className="text-sm font-semibold text-gray-900" data-id="element-443">€50</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-100" data-id="element-444">
                <div data-id="element-445">
                  <h4 className="text-sm font-medium text-gray-800" data-id="element-446">
                    3 erfolgreiche Empfehlungen
                  </h4>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-447">
                    PayPal-Auszahlung
                  </p>
                </div>
                <span className="text-sm font-semibold text-gray-900" data-id="element-448">
                  €150
                </span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-100" data-id="element-449">
                <div data-id="element-450">
                  <h4 className="text-sm font-medium text-gray-800" data-id="element-451">
                    5 erfolgreiche Empfehlungen
                  </h4>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-452">
                    Premium-Account-Upgrade
                  </p>
                </div>
                <span className="text-sm font-semibold text-gray-900" data-id="element-453">
                  1 Jahr
                </span>
              </div>
              <div className="text-center mt-4" data-id="element-454">
                <button className="text-orange-500 text-sm font-medium hover:text-orange-600" data-id="element-455">
                  Prämien bearbeiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};